import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper, FlatFeeModalWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { Table } from 'reactstrap';
import Select from 'web/components/form-elements/Select';
import states from 'states-us';
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import YesNoModal from "web/components/YesNoModal";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddUserModal from './AddUserModal'
import AddEditLocationModal from './AddEditLocationModal'
import AlertModal from 'web/components/AlertModal';
import { fetchAdminLocationListApi, adminFetchLocationUsersListApi, deleteLocation, activeLocation, deactiveLocation, deleteCustomer, reInviteApi } from 'redux/actions/adminPtPlus/index';
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import CloseIcon from "web/assets/images/CloseIcon.png";

function LocatoinSetUp(pageProps) {
  const dispatch = useDispatch();
  let history = useHistory()
  const [pageView, setPageView] = useState('locationsList')
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [addUserModal, setAddUserModal] = useState(false)
  const [addLocationModal, setAddLocationModal] = useState(false)
  const [editLocationDetails, setEditLocationDetails] = useState()
  const [locationsList, setLocationsList] = useState([])
  const [locationUsersList, setLocationUsersList] = useState([])
  const [clickedLocationDetails, setClickedLocationDetails] = useState()
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');

  const [deactiveState, setDeactiveState] = useState(false)

  const [locationVal, setLcationVal] = useState();
  const [deleteType, setDeleteType] = useState();

  const [selectedId, setSelectedId] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(false);
  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [locationStatus, setLocationStatus] = useState("");

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = []
  for (let i = 0; i < territoryStates.length; i++) {
    if (territoryStates[i].name !== 'District Of Columbia') {
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation
      }
      stateArr.push(obj)
    }
  }

  let headerArr = [
    { title: 'Locations', },
    { title: 'Users', },
    { title: 'Associated Orders', },
    { title: 'Action', },
    // { title: '', }
  ];

  let usersheaderArr = [
    { title: 'User Name', },
    { title: 'Email', },
    { title: 'Action', },
  ];

  useEffect(() => {
    fetchLocationsListFunction()
  }, [])

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }
  const [mainLocationId, setMainLocationId] = useState(false);
  const fetchLocationsListFunction = async (locationVal) => {
    let response = ''
    let id = pageProps.pageData.id
    const token = localStorage.getItem('token')
    response = await dispatch(fetchAdminLocationListApi(id, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response.success) {
        let mainlocationsListTemp = []
        let sublocationsListTemp = []
        if (response.data.locations?.length > 0 && response.data.locations[0].mainLocation) {
          mainlocationsListTemp = [response.data.locations[0].mainLocation]
          setMainLocationId(response.data.locations[0].mainLocation.locationId)
          setLocationStatus(response?.data?.locations[0]?.mainLocation?.customers[0]?.status)
        }
        if (response.data.locations?.length > 0 && response.data.locations[0].subLocations?.length > 0) {
          sublocationsListTemp = response.data.locations[0].subLocations
        }
        let locationsListTemp = [...mainlocationsListTemp, ...sublocationsListTemp]

        setLocationsList(locationsListTemp)


        if (locationVal) {
          for (let k = 0; k < locationsListTemp.length; k++) {
            if (locationsListTemp[k].locationId === locationVal?.locationId) {

              locationIdClickHandler(locationsListTemp[k])
            }
          }
        }

      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }
  const deleteApi = async (val) => {
    const token = localStorage.getItem('token')
    let response = await dispatch(deleteLocation(val.locationId, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        setLocationsList()
        setPageView('locationsList')
        setLcationVal()
        fetchLocationsListFunction()
        setAlertModalContent("Location deleted successfully.")
        setAlertModal(!alertModal)
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }
  const deactiveApi = async (val) => {
    const token = localStorage.getItem('token')
    let response = await dispatch(deactiveLocation(val.locationId, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        setLocationsList()
        setPageView('locationsList')
        setLcationVal()
        fetchLocationsListFunction()
        setAlertModalContent(response?.data?.msg)
        setAlertModal(!alertModal)
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const activeApi = async (val) => {
    const token = localStorage.getItem('token')
    let response = await dispatch(activeLocation(val.locationId, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        setLocationsList()
        setPageView('locationsList')
        setLcationVal()
        fetchLocationsListFunction()
        setAlertModalContent("Location activated successfully.")
        setAlertModal(!alertModal)
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }
  const deleteCustomerApi = async (val) => {
    const token = localStorage.getItem('token')
    let data = {
      "customerIds": [val.customerId]
    }
    let response = await dispatch(deleteCustomer(data, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        setLocationUsersList([])
        setLocationsList()
        setPageView('locationsList')
        fetchLocationsListFunction(locationVal)
        setAlertModalContent("Subuser deleted successfully.")
        setAlertModal(!alertModal)
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const locationIdClickHandler = (val) => {
    if (!val.isActive) {
      setDeactiveState(true)
    } else {
      setDeactiveState(false)
    }

    val.customers.forEach((value) => {
      value.locationId = val.locationId
    })
    let locationUsersList = JSON.parse(JSON.stringify(val.customers))
    setLocationUsersList(locationUsersList)
    setPageView('locationUsersList')
  }

  const addUserClickHandler = items => {
    if (items.customers?.length === 5) {
      setAlertModalContent('Only maximum of 5 users permitted in a location.')
      setAlertModal(!alertModal)
    } else {
      setClickedLocationDetails(items)
      setAddUserModal(true)
    }
  }

  const subUserreInviteFunction = async (data) => {

    const token = localStorage.getItem('token')
    let apiData =
    {
      "emailAddress": data?.email,
      "subLocationId": data?.locationId
    }
      ;

    let response = await dispatch(reInviteApi(apiData, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        // fetchLocationsListFunction()
        setAlertModalContent(response.data.msg)
        setAlertModal(!alertModal)
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }

  return (
    <>
      <Container>
        <AccordionHeader>
          <h6 onClick={() => {
            if (accordionOpen) setAccordionOpen(false)
            else setAccordionOpen(true)
          }}>Location and User Setup</h6>
          {accordionOpen ?
            <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
            : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
          }
        </AccordionHeader>
        {accordionOpen &&
          <AccordionBody>
            {pageView === 'locationsList' ?
              <InputFieldsWrapper>
                <div style={{ display: 'flex', marginBottom: '10px', justifyContent: 'space-between' }}>
                  <p style={{ color: '#000000', margin: '0px 0px 0px 11px', fontSize: '13px' }}>Use the section to add sub-accounts for other locations in your network, and to manage users for your main account or sub-accounts. Every location can have up to three user accounts.</p>
                  <div style={{ display: 'flex', justifyContent: 'end', width: '220px' }}>
                    <button className='green-button'
                      onClick={() => {
                        setEditLocationDetails()
                        setAddLocationModal(true)
                      }}
                    ><AddPlusIcon />Add Locations</button>
                  </div>
                </div>
                <div>
                  <Table responsive>
                    <thead>
                      <tr>
                        {headerArr.map((items, index) => (
                          <th key={index}>
                            {items.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {locationsList && locationsList.map((val, index) => {
                        return (
                          <tr key={index} className='flat-fee-table-data'>
                            <td style={{ cursor: 'pointer', color: '#00b3ff' }}
                              onClick={() => {
                                setLcationVal(val)
                                locationIdClickHandler(val)

                              }}>{`${val.address?.locationName} - ${val.address?.street}, ${val.address?.city}, ${val.address?.state}`}</td>
                            <td>{val.customers?.length}</td>
                            <td>{val?.ordersAssociated}</td>
                            <td style={{ display: 'flex' }}>
                              {index !== 0 ?
                                <button
                                  title='Edit Location Details'
                                  style={{ border: 'none', background: '#fff', paddingLeft: 0 }}
                                  onClick={e => {
                                    setEditLocationDetails(val)
                                    setAddLocationModal(true)
                                  }}
                                >
                                  <EditIcon />
                                </button>
                                : <div style={{ width: '35px' }}></div>
                              }
                              {val?.isActive && locationStatus !== "PENDING" ? <button style={{ border: '1.5px solid #005586', 'margin-right': '10px', borderRadius: '3px', background: '#fff', height: '25px' }}
                                onClick={() => addUserClickHandler(val)}>Add User</button> : <div style={{ "display": "inline-block" }}></div>}

                              {!val.orderAssociated && !val.userAssociated && !val.requestwdOrderAssociated && val?.isActive !== false && mainLocationId !== val?.locationId &&
                                <button className='green-button' style={{ width: '85px', height: '24px', 'margin-right': '10px' }}
                                  onClick={() => {
                                    setDeleteType("location")
                                    setYesNoModalContent("Do you want to delete the location?")
                                    yesNoToggleModal()
                                    setSelectedId(val)
                                    // deleteApi(val)
                                  }}>Delete</button>}

                              {!val.orderAssociated && !val.requestwdOrderAssociated && mainLocationId !== val?.locationId && <>
                                {val.userAssociated && <button className='green-button' style={{ width: '85px', height: '24px', 'margin-right': '10px' }}
                                  onClick={() => {
                                    setDeleteType("location")
                                    setYesNoModalContent("Do you want to delete the location?")
                                    yesNoToggleModal()
                                    setSelectedId(val)
                                    // deleteApi(val)
                                  }}>Delete</button>}

                                {val?.isActive && val?.customers.length !== 0 && val?.anyUserActive && mainLocationId !== val?.locationId ?
                                  <button className='green-button' style={{ width: '85px', height: '24px' }}
                                    onClick={() => {
                                      setDeleteType("DeactivateLocation")
                                      setYesNoModalContent("Do you want to deactive the location?")
                                      yesNoToggleModal()
                                      setSelectedId(val)
                                      // deleteApi(val)
                                    }}>Deactivate</button>
                                  :
                                  <>{val?.isActive === false && <button className='green-button' style={{ width: '85px', height: '24px' }}
                                    onClick={() => {
                                      setDeleteType("activateLocation")
                                      setYesNoModalContent("Do you want to active the location?")
                                      yesNoToggleModal()
                                      setSelectedId(val)
                                      // deleteApi(val)
                                    }}>Activate</button>}</>
                                }
                              </>}

                              {(val.orderAssociated || val.requestwdOrderAssociated) && val?.isActive && mainLocationId !== val?.locationId && <button className='green-button' style={{ width: '85px', height: '24px' }}
                                onClick={() => {
                                  setDeleteType("DeactivateLocation")
                                  setYesNoModalContent("Do you want to deactivate the location?")
                                  yesNoToggleModal()
                                  setSelectedId(val)
                                }}>Deactivate</button>}

                              {(val.orderAssociated || val.requestwdOrderAssociated) && !val?.isActive && <button className='green-button' style={{ width: '85px', height: '24px' }}
                                onClick={() => {
                                  setDeleteType("activateLocation")
                                  setYesNoModalContent("Do you want to activate the location?")
                                  yesNoToggleModal()
                                  setSelectedId(val)
                                }}>Activate</button>}
                            </td>

                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              </InputFieldsWrapper>
              :
              <InputFieldsWrapper>
                <div className='userlist-header'>
                  <h1 style={{ marginLeft: '11px' }}>Users List</h1>
                  <img src={CloseIcon} alt="close-icon" onClick={() => setPageView('locationsList')} />
                </div>
                <div>
                  <Table responsive>
                    <thead>
                      <tr>
                        {usersheaderArr.map((items, index) => (
                          <th key={index}>
                            {items.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {locationUsersList && locationUsersList.map((val, index) => {
                        return (
                          <tr key={index} className='flat-fee-table-data'>
                            <td>{val.name}</td>
                            <td>{val.email}</td>
                            <td>
                              {!deactiveState && <>
                                {val.subuser && <button className='green-button' style={{ width: '85px', height: '24px' }}
                                  onClick={() => {
                                    setDeleteType("customer")
                                    setYesNoModalContent("Do you want to delete the user?")
                                    yesNoToggleModal()
                                    setSelectedCustomerId(val)
                                  }}>Delete</button>}{' '}
                                {val.subuser && val.active === false && <button className='green-button' style={{ width: '85px', height: '24px' }}
                                  onClick={() => {
                                    subUserreInviteFunction(val)
                                  }}>Reinvite</button>}
                              </>}

                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              </InputFieldsWrapper>
            }
          </AccordionBody>
        }
      </Container>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
      />

      <YesNoModal
        isOpen={yesNomodal}
        toggle={yesNoToggleModal}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (deleteType === "customer") {
              deleteCustomerApi(selectedCustomerId)
              setSelectedCustomerId("")
            } else {
              if (deleteType === "DeactivateLocation") {
                deactiveApi(selectedId)
                setSelectedId("")
              } else if (deleteType === "activateLocation") {
                activeApi(selectedId)
                setSelectedId("")
              } else {
                deleteApi(selectedId)
                setSelectedId("")
              }

            }

          }
        }}
        content={yesNoModalContent}
        link="/"
      />
      <Modal isOpen={addLocationModal} centered={true}>
        <FlatFeeModalWrapper>
          <ModalBody>
            <AddEditLocationModal
              pageData={pageProps.pageData}
              formikProps={pageProps.formikProps}
              setFieldValue={pageProps.setFieldValue}
              editLocationDetails={editLocationDetails}
              fetchLocationsListFunction={fetchLocationsListFunction}
              refreshUserData={pageProps.refreshUserData}
              toggle={() => setAddLocationModal(false)} />
          </ModalBody>
        </FlatFeeModalWrapper>
      </Modal>

      <Modal isOpen={addUserModal} centered={true}>
        <FlatFeeModalWrapper>
          <ModalBody>
            <AddUserModal
              pageData={pageProps.pageData}
              formikProps={pageProps.formikProps}
              setFieldValue={pageProps.setFieldValue}
              fetchLocationsListFunction={fetchLocationsListFunction}
              clickedLocationDetails={clickedLocationDetails}
              toggle={() => setAddUserModal(false)} />
          </ModalBody>
        </FlatFeeModalWrapper>
      </Modal>
    </>
  )
}

export default LocatoinSetUp